import type { FileAttachmentTypeT } from '@lotushealth/lotushealth_js_sdk/schemas';

/**
 * Query keys for file attachment data.
 *
 * Keep these stable and parameterized by userId, attachmentId, and fileType.
 */
export const fileAttachmentKeys = {
  all: ['file-attachments'] as const,
  viewUrl: (userId: string, attachmentId: string, fileType: FileAttachmentTypeT) =>
    [...fileAttachmentKeys.all, 'view-url', userId, attachmentId, fileType] as const,
};
